<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <jobs-page />
    </div>
  </div>
</template>

<script>
import JobsPage from '../Components/JobsPage.vue';
export default {
  name: 'Jobs',
  components: {
    'jobs-page': JobsPage,
  },
};
</script>
